import ZoomInRounded from "@mui/icons-material/ZoomInRounded";
import { Box, Fab } from "@mui/material";
import type { FC } from "react";
import type { Asset } from "../../../../../assets/server/digital-asset-service";
import { constructCloudflareStreamUrl } from "../../../../../assets/utils";
import { CustomTemplateChip } from "../../../../../content-previews/custom-template-chip";
import { FileIconWithChip } from "../../../../../generic/components/icon-with-chip";

export const AssetPreview: FC<{
  asset: Asset;
  showPreviewIcon: boolean;
  height?: string | number;
  iconFontSize?: number;
  videoPlayer?: boolean;
  designer?: string | null;
  showChips?: boolean;
}> = ({
  asset,
  showPreviewIcon,
  height = "300px",
  iconFontSize,
  videoPlayer,
  designer,
  showChips = true,
}) => {
  const isVideo =
    asset.content_type === "Video" ||
    (asset.content_type === "Uploaded File" && asset.mime_type?.startsWith("video"));
  const isPdfUploadedFile =
    asset.content_type === "Uploaded File" && asset.mime_type === "application/pdf";
  const shouldShowPdfIndicator = isPdfUploadedFile && (showChips || !asset.thumbnail_url);

  return (
    <Box
      role="img"
      sx={{
        height,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      {asset.thumbnail_url && (
        <Box
          component="img"
          src={asset.thumbnail_url}
          draggable={false}
          decoding="sync"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "contain",
            zIndex: 0,
          }}
        />
      )}
      {shouldShowPdfIndicator && (
        <Box sx={{ position: "relative" }}>
          <FileIconWithChip fileType={showChips ? "PDF" : undefined} fontSize={iconFontSize} />
        </Box>
      )}
      {isVideo && videoPlayer && (
        <iframe
          src={`${constructCloudflareStreamUrl(asset.external_storage_id)}/iframe`}
          style={{ border: "none", height: "100%", width: "100%", zIndex: 1 }}
          allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
          allowFullScreen
          title="Video Preview"
        ></iframe>
      )}
      {showPreviewIcon && (
        <Box sx={{ position: "absolute", zIndex: 1 }}>
          {/* Forced to be a non-button */}
          <Fab color="primary" component="span">
            <ZoomInRounded />
          </Fab>
        </Box>
      )}
      {showChips && asset.custom_source_template && (
        <CustomTemplateChip designer={designer ?? null} />
      )}
    </Box>
  );
};
